import { z } from 'zod'
import { BlogPostStatus } from '../constants/s360app-compat'

export const blogPostCreateSchema = z.object({
  client_id: z.string().min(1, 'Client ID is required'),
  title: z.string().min(1, 'Title is required'),
  slug: z.string().min(1, 'Slug is required').regex(/^[a-z0-9-]+$/, 'Slug must be lowercase alphanumeric with hyphens'),
  meta_description: z.string().max(160).optional(),
  author: z.string().optional(),
  category_id: z.string().optional(),
  sections: z.string().min(1, 'Sections content is required'),
  cta_text: z.string().optional(),
  cta_link: z.string().url().optional(),
  cta_variant: z.string().optional(),
})

export const blogPostUpdateSchema = z.object({
  title: z.string().min(1).optional(),
  slug: z.string().regex(/^[a-z0-9-]+$/).optional(),
  meta_description: z.string().max(160).optional(),
  featured_image_r2: z.string().optional(),
  featured_image_alt: z.string().optional(),
  category_id: z.string().optional(),
  cta_text: z.string().optional(),
  cta_link: z.string().url().optional(),
  cta_variant: z.string().optional(),
  sections: z.string().optional(),
  status: BlogPostStatus.optional(),
})

export const blogCategoryCreateSchema = z.object({
  name: z.string().min(1, 'Category name is required'),
  slug: z.string().min(1).regex(/^[a-z0-9-]+$/),
  display_order: z.number().int().min(0).optional(),
})
